// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__jV4kM","inputWrap":"CustomTip_inputWrap__1XK54"};